// extracted by mini-css-extract-plugin
module.exports = {"scroll":"form_scroll__3UXQG","amount":"form_amount__4ACQQ","footer":"form_footer__2UZSI"};